
export const sFechaPublicacion = '2026-09-28T09:27:41.3147728-06:00';
export const sVersion = 'vf1.1.609280927';
            